import * as React from "react";
const IconPlusMinusSymbol1 = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M42 26.5h-9v-9c0-.6-.4-1-1-1s-1 .4-1 1v9h-9c-.6 0-1 .4-1 1s.4 1 1 1h9v9c0 .6.4 1 1 1s1-.4 1-1v-9h9c.6 0 1-.4 1-1s-.5-1-1-1M42 45.5H22c-.6 0-1 .4-1 1s.4 1 1 1h20c.6 0 1-.4 1-1s-.5-1-1-1" />
    <path d="M32 2C15.5 2 2 15.5 2 32s13.5 30 30 30 30-13.5 30-30S48.5 2 32 2m0 58C16.6 60 4 47.4 4 32S16.6 4 32 4s28 12.6 28 28-12.6 28-28 28" />
  </svg>
);
export default IconPlusMinusSymbol1;
